 <ng-container *ngIf="isStudyLoading; else coursePageContent">
	<div class="app-spinner">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>

<ng-template #coursePageContent>
	<ng-container *ngIf="_studyMaterialSent.length > 0 || _studyMaterialReceived.length > 0; else noPageContent ">
<div class="d-flex">
		<h2 class="study-head mt-1">Study Materials</h2>
    <span class="count-badge ms-2 mt-1">{{ _totalMaterialLength }}</span>
</div>
  <div class="study-grid mt-3">
	<ng-container *ngFor="let studyMaterial of _studyMaterialSent">
  <ng-container *ngFor="let material of studyMaterial.materials">
    <div class="study-card" *ngIf="material?.is_material_file && material?.material_name?.trim()">
      <div class="material-header justify-content-between">
		<div class="text-start">
        <img src="assets/images/note02.svg" alt="file icon" class="me-3"/>
        <span class="material-title truncate-url"
	   [matTooltip]="material?.material_name ?? '' ">
	 {{ material?.material_name || '-'}}</span>
      </div>
	  <div class="text-end">
		  <div class="text-end">
		  <button [matMenuTriggerFor]="menu" class="plain-icon">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openDeleteDialogMaterialBox(studyMaterial.id)">Delete</button>
              </mat-menu>
			  </div>
	  </div>
	  </div>

      <div class="material-meta">
        <span class="date"><i class="bi bi-calendar"></i> {{ convertToIST(studyMaterial.created_at)}}</span>
      </div>
      <hr />

      <div class="button-container" *ngIf="material">
		<a [href]="material.original_file_s3_url || material.extracted_file_s3_url" 
           target="_blank" class="download-btn">
          <i class="bi bi-download download-btn"></i> Download</a>
      </div>
    </div>
	</ng-container>
   </ng-container>

<ng-container *ngFor="let receivedStudyMaterial of _studyMaterialReceived">
	  <ng-container *ngFor="let announcement of receivedStudyMaterial.announcements || []">
	<ng-container *ngFor="let receivedMaterial of announcement.materials">
    <div class="study-card" *ngIf="receivedMaterial?.is_material_file &&
		receivedMaterial?.material_name?.trim()">
      <div class="material-header justify-content-between">
		<div class="text-start">
        <img src="assets/images/note02.svg" alt="file icon" class="me-3"/>
        <span class="material-title truncate-url"
		[matTooltip]="receivedMaterial?.material_name ?? '' ">
			{{ receivedMaterial?.material_name || '-'}}</span>
      </div>
	  </div>

      <div class="material-meta">
        <span class="date"><i class="bi bi-calendar"></i> {{ convertToIST(announcement.created_at)}}</span>
      </div>
      <hr />
      <div class="button-container" *ngIf="receivedMaterial">
		<a [href]="receivedMaterial.original_file_s3_url || receivedMaterial.extracted_file_s3_url" 
           target="_blank" class="download-btn">
          <i class="bi bi-download download-btn"></i> Download</a>
      </div>
    </div>
	</ng-container>
</ng-container>
</ng-container>
  </div>
  </ng-container>

   <ng-template #noPageContent>
      <div class="text-center mt-5">
        <p>No Study Material Found</p>
      </div>
    </ng-template>
  </ng-template>